import {toastr} from "react-redux-toastr";
import {Button} from "reactstrap";
import apiClient from "../../gears/apiClient"
import {ACCESSOR, HEADERS} from "../tables/Issues/Issues-columns.helper";

export const getIssuesByCategory = async (data) => {
  try {
    return await apiClient.get('/disruption-logs', data);
  } catch(error) {
    toastr.error(error?.message);
    return null;
  }
}

export const networkIssuesSearchByColumnOptions = (type = '', appArray = []) =>  {
  const columns = [
    {
      value: 'all',
      label: 'All',
      type: 'single_select',
    },
    {
      value: 'active',
      label: 'Active',
      type: 'single_select',
    },
    {
      value: 'new',
      label: 'New',
      type: 'single_select',
    },
  ];

  switch(type) {
    case 'reported':
      columns.push({
        value: 'completed',
        label: 'Completed',
        type: 'single_select'
      });
      break;

    case 'application':
      columns.push({
        value: 'app',
        label: 'Application',
        type: 'select',
        options: appArray.map((app) => ({
          value: app.id,
          label: app.name,
        })),
      });
      break;

    default:
      break;
  }

  return columns;
};

// Badge style based on priority level
const getBadgeColor = (status) => {
  if (status === 'Completed') {
    return 'bg-green-100 text-green-800';
  }
  return 'bg-yellow-100 text-yellow-800';
};

const reportedIssuesTableColumns = [
  {
    Header: HEADERS.STATUS,
    accessor: ACCESSOR.STATUS,
    Cell: ({ row: { original }}) => {
      return (
        <span className={`text-xs px-2 py-1 rounded-full ${getBadgeColor(original.status)}`}>
          {original.status}
        </span>
      );
    },
  },
  {
    Header: HEADERS.EMAIL,
    accessor: ACCESSOR.EMAIL,
  },
  {
    Header: HEADERS.TIMESTAMP,
    accessor: ACCESSOR.CREATED_AT,
  },
  {
    Header: HEADERS.DESCRIPTION,
    accessor: ACCESSOR.DESCRIPTION,
    disableSortBy: true,
  },
];

export const issuesTableColumns = (onDrawerOpen, type = '') => {
  const columns = [
    {
      Header: HEADERS.STATUS,
      accessor: ACCESSOR.STATUS,
      Cell: ({ row: { original }}) => {
        return (
          <span className={`text-xs px-2 py-1 rounded-full ${getBadgeColor(original.status)}`}>
          {original.status}
        </span>
        );
      },
    },
    {
      Header: HEADERS.EMAIL,
      accessor: ACCESSOR.EMAIL,
    },
    {
      Header: HEADERS.APP_NAME,
      accessor: ACCESSOR.APP,
      isVisible: type === 'application',
    },
    {
      Header: HEADERS.EVENT_TYPE,
      accessor: ACCESSOR.TYPE,
      Cell: ({ row: { original }}) => {
        if (original.type.toLowerCase() === 'high packet loss') {
          return (
            <Button color="link" className="p-0" onClick={() => onDrawerOpen(original.test_id)}>
              <span style={{textTransform: 'capitalize', textDecoration: 'underline'}}>{original.issue_type}</span>
            </Button>
          );
        }
        return <span style={{textTransform: 'capitalize'}}>{original.type}</span>;
      },
    },
    {
      Header: HEADERS.SEVERITY,
      accessor: ACCESSOR.SEVERITY,
    },
    {
      Header: HEADERS.START_TIME,
      accessor: ACCESSOR.START,
      disableSortBy: true,
      Cell: ({ row: { original }}) => (
        original.start|| 'N/A'
      ),
    },
    {
      Header: HEADERS.END_TIME,
      accessor: ACCESSOR.END,
      disableSortBy: true,
      Cell: ({ row: { original }}) => (
        original.end || 'N/A'
      ),
    },
    {
      Header: HEADERS.DURATION,
      accessor: ACCESSOR.DURATION,
    },
    {
      Header: HEADERS.ISP,
      accessor: ACCESSOR.ISP,
      disableSortBy: true,
      Cell: ({ row: { original }}) => (
        original?.location?.isp || 'N/A'
      ),
    },
  ];

  switch(type) {
    case 'reported':
      return reportedIssuesTableColumns;
    case 'helpdeskRequest':
      return reportedIssuesTableColumns.filter(column => column.accessor !== 'status');
    default:
      break
  }
  return columns;
};
